import React, { useState, useEffect } from "react";
import { Collapse, Button } from "antd";
import VariantProductItem from "./VariantProductItem";
import { PlusOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from 'uuid';


const { Panel } = Collapse;

const VariantProductList = ({ setSavedVariants, variantdata, newdata = null, form }) => {
  const [products, setProducts] = useState([]);
  const [defaultOptionID, setdefaultOptionID] = useState(0)
  const [hasDuplicateError, setHasDuplicateError] = useState(false);


  useEffect(() => {
    const fetchData = async () => {

      if (variantdata && variantdata.variant_data) {
        variantdata.variantdata = variantdata
        if (variantdata.variant_options && variantdata.variant_options.length > 0) {
          setdefaultOptionID(variantdata.variant_options[0].option_id)
        }
      }
      if (variantdata && variantdata.variant_data && variantdata.variant_data.length > 0) {
        const mapdata = await variantdata.variant_data.map((item, index) => {
         
          
          return {
            id: item.id == 0 ? item.variant_sku : item.id,
            key: item.id == 0 ? item.variant_sku : item.id,
            bc_product_id: item.bc_product_id,
            name: item.variant_values,
            editable: true,
            quantity: 1,
            weight: item.weight,
            variant_sku: item.variant_sku,
            variant_image: item.variant_image,
            variant_name: item.variant_name,
            variant_msrp: item.variant_msrp,
            variant_sale_price: item.variant_sale_price,
            inventory_available: item.inventory_available,
            purchasing_disabled: item.purchasing_disabled,
            sap_msrp: item.sap_data ? item.sap_data.sap_msrp : "NA",
            sap_sale: item.sap_data ? item.sap_data.sap_sale : "NA",
            sap_inventory: item.sap_data ? item.sap_data.sap_inventory : "NA",
            inventory_warning_level: item.inventory_warning_level,
            variant_default_price: item.variant_default_price,
            width: item.width,
            height: item.height,
            variant_id: item.variant_id,
            depth: item.depth,
            options: JSON.parse(item.options),
            store_id: item.store_id,
            is_new: item.id == 0 ? true : false,
            currency_symbol: item.currency_symbol
          }
        })

        setProducts(mapdata)
      }

    }

    if (variantdata) {
      fetchData()
    }
  }, [variantdata]);

  useEffect(() => {
    const fetchData = async () => {
      if (newdata) {
        const mapdata = await newdata.map((item, index) => {
          return {
            key: item.variant_sku,
            id: 0,
            bc_product_id: 0,
            name: item.description,
            editable: true,
            quantity: 1,
            weight: "",
            variant_sku: item.sku,
            variant_image: "",
            variant_name: item.name,
            variant_msrp: item.msrp,
            variant_sale_price: item.sale_price,
            inventory_available: item.inventory_available,
            sap_msrp: item.msrp,
            sap_sale: item.sale_price,
            sap_inventory: item.inventory_available ? item.inventory_available : "NA",
            inventory_warning_level: 0,
            variant_default_price: item.msrp,
            width: "",
            height: "",
            variant_id: 0,
            depth: "",
            options: [],
            store_id: item.store_id,
            is_new: true,
            currency_symbol: item.currency_symbol
          }
        })
        setProducts(mapdata)
      }
    }

    if (newdata) {
      fetchData()
    }
  }, [newdata])

  useEffect(() => {

    setSavedVariants({ variants: products, hasDuplicateError });
  }, [products, setSavedVariants, hasDuplicateError]);

  const generateUniqueId = () => `${Date.now()}-${Math.floor(Math.random() * 100000)}`;

  const addProduct = () => {
    setProducts([
      ...products,
      {
        id: Date.now(),
        key: Date.now(),
        name: "",
        editable: true,
        quantity: 1,
        width: "",
        is_new: true,
        store_id: products[0]?.store_id || null,
        cost_price: "",
        depth: "",
        height: "",
        options: defaultOptionID ? [{ option_id: defaultOptionID }] : [],
      },
    ]);
  };

  const removeProduct = (id) => {
    setProducts(products.filter((product) => product.id !== id));
  };

  const updateProduct = (id, updatedFields) => {
    setProducts(products.map((product) =>
      product.id === id ? { ...product, ...updatedFields } : product
    ));
  };

  return (
    <Collapse
      defaultActiveKey={["Variant"]}
      className="ProductDetailsCollapse"
      items={[
        {
          key: "Variant",
          label: `Variant (${products.length})`,
          children: (
            <>
              {products && products.map((product, index) => (
                <div key={product.id != 0 ? product.id : product.variant_sku}>
                  {product && <VariantProductItem
                    product={product}
                    onRemove={removeProduct}
                    onUpdate={updateProduct}
                    products={products}
                    setProduct={setProducts}
                    form={form}
                    index={index}
                    setHasDuplicateError={setHasDuplicateError}
                  />}
                </div>
              ))}

              {defaultOptionID !== 0 && (
                <Button
                  onClick={addProduct}
                  icon={<PlusOutlined />}
                  style={{ marginTop: 16 }}
                  disabled={
                    products.length > 0 &&
                    (
                      !products[products.length - 1].name ||
                      !products[products.length - 1].variant_sku
                    )
                  }
                >
                  Add Variant
                </Button>
              )}
            </>
          ),
        }
      ]}
    />
  );
};

export default VariantProductList;
